// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Product_overlay__E2wcm","overlayDesktop":"Product_overlayDesktop__d5an1"};